// @ts-nocheck
import DoubleCurrencyLogo from "components/DoubleLogo";
import { RowBetween } from "components/Row";
import { utils } from "ethers";
import { useToken } from "hooks/Tokens";
import useActiveWeb3React from "hooks/useActiveWeb3React";
import { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { PositionDetails } from "types/position";
import { unwrappedToken } from "utils/unwrappedToken";

import { gql, useQuery } from "@apollo/client";

const PrimaryPositionIdData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  > * {
    margin-right: 8px;
  }
`

const DataText = styled.div`
  font-weight: 600;
  font-size: 18px;
  color:white;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 14px;
  `};
`

interface PositionListItemProps {
  setActiveKey:(value: bundleID) => void;
  activeKey: bundleID;
  key: string;
  index: number;
  positionDetails: PositionDetails;
 }

const IMPORT_HISTORY_QUERY = gql`
  query GetHistories($bundle: String, $owner: String, $capital: String, $asset: String) {
    histories(where: {bundle: $bundle, owner: $owner, capital: $capital, asset: $asset, action: "AddLiquidity"}) {
      lpAmount
      capitalAmount
      assetAmount
      action
    }
  }
`

const EXPORT_HISTORY_QUERY = gql`
  query GetHistories($bundle: String, $owner: String, $capital: String, $asset: String) {
    histories(where: {bundle: $bundle, owner: $owner, capital: $capital, asset: $asset, action: "RemoveLiquidity"}) {
      lpAmount
      capitalAmount
      assetAmount
      action
    }
  }
`

export default function PositionListItemClosed({ setActiveKey, activeKey, index, positionDetails }: PositionListItemProps) {
  const {
    capital: token0Address,
    asset: token1Address,
    bundle: bundleID,
    fee,
    id
  } = positionDetails;
  const { account } = useActiveWeb3React()
  const [collapse, setCollapse] = useState(true);
  const removeClicked = false;

  const { data: importedData } = useQuery(IMPORT_HISTORY_QUERY, {
    variables: { bundle: bundleID, owner: account.toLowerCase(), capital: token0Address, asset: token1Address },
  });
  const { data: exportedData } = useQuery(EXPORT_HISTORY_QUERY, {
    variables: { bundle: bundleID, owner: account.toLowerCase(), capital: token0Address, asset: token1Address },
  });

  useEffect(()=>{
	  if(id===activeKey){
		  setCollapse(false)
	  }else{
		  setCollapse(true)
	  }
	  
  },[activeKey, id])

  const changeCollpase = () => {
      if (collapse){
      setActiveKey(id);
    }
    else{
      setActiveKey("");
    }
  }

  const token0 = useToken(token0Address)
  const token1 = useToken(token1Address)

  const currency0 = token0 ? (token0.tokenInfo ? token0.tokenInfo : unwrappedToken(token0)) : undefined
  const currency1 = token1 ? (token1.tokenInfo ? token1.tokenInfo : unwrappedToken(token1)) : undefined

  return (
    // <LinkRow to={positionSummaryLink}>
    <>
      <RowBetween>
        <>{!removeClicked ? 
        <>
         <div className="single-liquidity" style={index%2===0?{backgroundColor:'#2F2A3C'}:{backgroundColor:'#201D29'}}>
            <div onClick={changeCollpase} style={{ cursor: "pointer" }}>
              <div className="single-liquidity-header">
                <div className="single-liquidity-header-left">
                <PrimaryPositionIdData>
                  {
                    currency0 && currency1 &&
                      <>
                        <DoubleCurrencyLogo currency0={currency0} currency1={currency1} size={36} margin />
                        <DataText>
                          &nbsp;{currency0?.symbol}&nbsp;{(currency0 && currency1) ? "/" : ""}&nbsp;{currency1?.symbol}&nbsp;&nbsp;
                          (#{bundleID})&nbsp;&nbsp;
                          {"(Closed)"}
                        </DataText>
                        &nbsp;
                      </>
                  }
                </PrimaryPositionIdData>
                </div>
                <div className="single-liquidity-header-right">
                  <img src="./images/up2.png" alt="up" style={{ width: "20px", height: "20px", display: collapse ? "none" : "block" }} />
                  <img src="./images/down2.png" alt="down" style={{ width: "20px", height: "20px", display: collapse ? "block" : "none" }} />
                </div>
              </div>
            </div>
            <div className="single-liquidity-content" style={{ height: collapse ? "0px" : "160px", overflow: 'hidden' }}>
              {/*<div style={{ display: collapse ? "none" : "flex", justifyContent: "space-between" }}>*/}
              {/*  <p className="single-token-left">Pair imported</p>*/}
              {/*  <p className="single-token-right">{(+(utils.formatUnits(importedData?.lpAmount ? importedData?.lpAmount : 0, 18))).toFixed(8)} LP</p>*/}
              {/*</div>*/}
              <div style={{ display: collapse ? "none" : "flex", justifyContent: "space-between" }}>
                <p className="single-token-left">Capital supplied</p>
                <p className="single-token-right">{(+utils.formatUnits(importedData?.histories[0]?.capitalAmount ? importedData?.histories[0]?.capitalAmount : 0, currency0?.decimals)).toFixed(6)} {currency0?.symbol}</p>
              </div>
              {/*<div style={{ display: collapse ? "none" : "flex", justifyContent: "space-between" }}>
                <p className="single-token-left">Token imported</p>
                <p className="single-token-right">{(+utils.formatUnits(importedData?.assetAmount ? importedData?.assetAmount : 0, currency1?.decimals)).toFixed(8)} {currency1?.symbol}</p>
              </div>*/}
              <div style={{ display: collapse ? "none" : "flex", justifyContent: "space-between" }}>
                <p className="single-token-left">Capital Received</p>
                <p className="single-token-right">{(+utils.formatUnits(exportedData?.histories[0]?.capitalAmount ? exportedData?.histories[0]?.capitalAmount : 0, currency0?.decimals)).toFixed(6)} {currency0?.symbol}</p>
              </div>
              <div style={{ display: collapse ? "none" : "flex", justifyContent: "space-between" }}>
                <p className="single-token-left">Token received</p>
                <p className="single-token-right">{(+utils.formatUnits(exportedData?.histories[0]?.assetAmount ? exportedData?.histories[0]?.assetAmount : 0, currency1?.decimals)).toFixed(6)} {currency1?.symbol}</p>
              </div> 
              <div style={{ display: collapse ? "none" : "flex", justifyContent: "space-between" }}>
                <p className="single-token-left">Protocol Fee</p>
                <p className="single-token-right">{(+utils.formatUnits(fee ? fee : 0, currency0?.decimals)).toFixed(6)} {currency0?.symbol}</p>
              </div> 
            </div>
          </div> 
        </>
          :
          <div >
           
          </div>
        }
        </>
      </RowBetween>
    </>
  )
}
